var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import React from 'react';
import { space, layout, systemSxFromProps, } from '@revdotcom/vaporwave-system';
import { useButton } from '@react-aria/button';
import { forwardCommonProps } from '../Helpers/CommonProps';
import { ButtonSpecs, ButtonSizeSpecs } from '../Models/ButtonSpecs';
var warnInvalidLinkPropUsage = function (propName) {
    return console.warn("The ".concat(propName, " prop should not be used without an href value."));
};
var getTargetProp = function (href, target, rel, openInNewTab) {
    if (!href && openInNewTab) {
        warnInvalidLinkPropUsage('openInNewTab');
    }
    return {
        target: openInNewTab && !target ? '_blank' : target,
        rel: openInNewTab && !rel ? 'noopener noreferrer' : rel,
    };
};
var VaporwaveButton = function (_a, ref) {
    var _b = _a.sizeVariant, sizeVariant = _b === void 0 ? 'normal' : _b, _c = _a.variant, variant = _c === void 0 ? 'solid' : _c, _d = _a.color, color = _d === void 0 ? 'primary' : _d, openInNewTab = _a.openInNewTab, children = _a.children, rest = __rest(_a, ["sizeVariant", "variant", "color", "openInNewTab", "children"]);
    /* Render the button as an <a> tag if it will be used as a link. A <button> inside of an <a> is not valid html. */
    var Component = rest.href ? 'a' : 'button';
    var buttonProps = useButton(__assign(__assign({}, rest), { elementType: Component }), ref).buttonProps;
    /* Only include the target prop if we want to open in a new tab */
    var targetProp = getTargetProp(rest.href, rest.target, rest.rel, openInNewTab);
    var sx = __assign(__assign(__assign({}, ButtonSizeSpecs[sizeVariant]), ButtonSpecs[variant](color)), systemSxFromProps(rest, __spreadArray(__spreadArray([], space, true), layout, true)));
    return (_jsx(Component
    /* Apply "any" as ref is expecting React.Ref<HTMLButtonElement & HTMLAnchorElement> */
    , __assign({ 
        /* Apply "any" as ref is expecting React.Ref<HTMLButtonElement & HTMLAnchorElement> */
        ref: ref }, buttonProps, targetProp, forwardCommonProps(rest), { sx: sx, children: children })));
};
/**
 * Renders a vaporwave Button with the phrasing content in children.
 *
 * The vaporwave Button can operate both as a button and a link depending on the props
 * used. In the presence of the href prop, the Button will act as a link and will
 * direct to the provided url. Otherwise, the button's onClick functionality is
 * determined by the provided handler.
 *
 * Spacing and width for the button should be defined using the styled-system props
 * (mt, mr, mb, ml, width, etc.).
 */
export var Button = React.forwardRef(VaporwaveButton);
